





































import Vue from 'vue'
import { Button, Progress } from 'element-ui'
import fb from '../../firebase'
import './ImageUploader.scss'

export default Vue.extend({
  name: 'ImageUploader',
  props: {
    value: {
      type: String,
      required: false
    },
    width: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    uploadTask: null as null|firebase.storage.UploadTask,
    uploadPercent: 0
  }),
  beforeDestroy () {
    this.cleanup()
  },
  methods: {
    openFileDialog () {
      const dialog = this.$refs.fileinput as HTMLInputElement
      dialog.click()
    },
    deleteImage () {
      this.$confirm('Are you sure you want to remove the image?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$emit('input', '')
      }).catch(() => {
        //
      })
    },
    newFile () {
      const timestamp = (new Date()).getTime()
      const dialog = this.$refs.fileinput as HTMLInputElement
      const file = dialog && dialog.files && dialog.files[0]
      if (file === null) {
        return
      }
      this.uploadTask = fb.firestorage.ref(`user/${this.currentUserId}}/${timestamp}`).put(file)
      this.uploadTask.on('state_changed', sp => {
        console.log('upload state ', sp)
        this.uploadPercent = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      },
      error => {
        this.cleanup()
        console.error(`Error uploading image ${error}`)
      }, () => {
        if (this.uploadTask) {
          this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.$emit('input', downloadURL)
            this.cleanup()
          }).catch(error => {
            this.cleanup()
            console.error(`Error uploading image ${error}`)
          })
        }
      })
    },
    cleanup () {
      this.uploadTask = null
    }
  },
  computed: {
    currentUserId (): string {
      return this.$store.direct.state.user.id
    },
    imagestyle (): Partial<CSSStyleDeclaration> {
      const style: Partial<CSSStyleDeclaration> = {
        height: `${this.width}px`,
        width: `${this.width}px`,
        objectFit: 'cover',
        objectPosition: 'center'
      }
      return style
    },
    emptystyle (): Partial<CSSStyleDeclaration> {
      const style: Partial<CSSStyleDeclaration> = {
        height: `${this.width}px`,
        width: `${this.width}px`,
        border: '1px gray solid',
        borderRadius: '5px',
        opacity: '0.5'

      }
      return style
    }
  },
  components: {
    'el-button': Button,
    'el-progress': Progress
  }
})
